var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.74 8.21V7.08c0-2.403 0-3.605-.709-4.352-.71-.747-1.85-.747-4.133-.747H6.823c-2.282 0-3.423 0-4.132.747-.71.747-.71 1.949-.71 4.353v3.642c0 2.404 0 3.606.71 4.353.548.578 1.355.709 2.749.738"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    d: "M5.094 11.664h2.767M5.094 8.206h5.533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    d: "M9.994 13.53c-.06.131-.106.27-.142.411l.142-.41Zm0 0 .029.029c-.057.124-.1.256-.134.392l.105-.42Zm-.196.864c.026-.15.054-.299.09-.443l-.09.443Zm0 0h-.004l-.033-.008c.026-.15.054-.299.091-.445l-.054.453Zm1.22 1.25c.15-.027.3-.055.445-.092l-.445.091Zm0 0-.007-.034m.007.033-.007-.033m0 0v-.003m0 .003v-.003m0 0a5.86 5.86 0 0 0 .443-.091l-.124-.485-.32.575Zm-.348-2.822-.014-.014-.013-.013 1.581-1.58.013.012.014.014-1.581 1.58Zm1.182 2.597.029.028c-.13.06-.27.106-.411.142l.383-.17Zm1.712-5.082-.022-.037h.08l-.02.037h-.038Zm1.547 1.548v-.038l.037-.022v.081l-.037-.021Zm-.903 1.313.013.013.013.013-1.58 1.581-.014-.013-.013-.014 1.58-1.58Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    d: "M7.17 15.815h.69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.094 1.981.057.341c.138.828.207 1.242.497 1.488.29.246.71.246 1.55.246h1.326c.84 0 1.26 0 1.55-.246.29-.246.359-.66.497-1.488l.056-.341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskEdit);
export default __webpack_public_path__ + "static/media/task-edit.d5e3f93b.svg";
export { ForwardRef as ReactComponent };